import AxiosWrapper, { axiosGetCallHeaderWithToken } from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";
const Base_URL = process.env.REACT_APP_BE_URL;
const { axiosGetCallWithToken, axiosPostCallWithToken } = AxiosWrapper;
const currentUrl = window.location.origin;
export const checkAssetType = async (id) => {
  const response = await axiosGetCallWithToken(
    `${Base_URL}/gsone/getAssetDetails?id=${id}`
  );
  return response;
};

//registration page to fetch plant list
export const getPlantOptions = async () => {
  const response = await axiosGetCallWithToken(`${Base_URL}/users/getAllTerminals`);
  return response;
};

//registration page to add records for specific asset id

export const submitFormData = async (formData) => {
  const response = await axiosPostCallWithToken(
    `${Base_URL}/gsone/addAssetData`,
    formData
  );
  return response;
};

//sparepart info page to fetch spare details for specific material

export const getSparePartDetails = async (material, storage_loc) => {
  // sessionStorage.setItem(
  //   "logingsoneurl",
  //   `/warehouse/spare-part-info?material_no=${material}`
  // );
  let scanSessionId = sessionStorage.getItem("scan_session_id");

  if (!scanSessionId) {
    scanSessionId = crypto.randomUUID();
    sessionStorage.setItem("scan_session_id", scanSessionId);
  }
  const response = await axiosGetCallWithToken(
    `${Base_URL}/gsone/getSparePartDetails?material=${material}&storage_loc=${storage_loc}&session_id=${scanSessionId}`
  );
  return response;
};

// Function to fetch row data based on ID from sq01
export const getSQ01ByID = async (id) => {
  const response = await axiosGetCallWithToken(
    `${Base_URL}/common/getSq01CatById?sq_id=${id}`
  );
  return response;
};

//fetch spbasketID to insert records in spbasket table
export const getSpBasketID = async () => {
  const response = await axiosGetCallWithToken(`${Base_URL}/dcatalogue/getSpBasketID`);
  return response;
};

// add data to spbasket table
export const postSpBasket = async (data, handleToastOpen) => {
  try {
    const response = await axiosPostCallWithToken(
      `${Base_URL}/dcatalogue/addSpBasket`,
      data
    );
    return response;
  } catch (error) {
    const errors = error.response.data.errors;
    // Check if the length of result matches the length of modellll
    const isLengthMatched = data.length === errors.length;

    if (isLengthMatched) {
      handleToastOpen("error", "All Records already present!");
    } else if (!isLengthMatched) {
      handleToastOpen("success", "Data added successfully!");
    }
  }
};

export const PutAway = async (data,handleToastOpen) => {
  try{
  const response = await axiosPostCallWithToken(
    `${Base_URL}/gsone/putAway`,
    data
  );
  return response;
  } catch (error) {
    throw error
    // Check if the length of result matches the length of modellll
    
  }};


// fetch fuel asset records
export const fetchMaterialData = async (asset_id, terminal) => {
  const response = await axiosGetCallWithToken(
    `${Base_URL}/get_gsone_data?equipment_number=${asset_id}&terminal=${terminal}`
  );
  return response;
};

// Function to fetch notification
export const getNotificationDetails = async (asset) => {
  try {
    const response = await axiosGetCallWithToken(
      `${Base_URL}/gsone/getNotificationDetails?asset=${asset}`
    );
    return response.data;
  } catch (error) {
    Logger.messageStackTrace("Error fetching sq01catById:", error);
  }
};

export const getWorkOrderDetails = async (asset, equipment, asset_id) => {
  try {
    sessionStorage.setItem(
      "logingsoneurl",
      `/warehouse/asset-info?asset_id=${asset_id}`
    );
    const response = await axiosGetCallWithToken(
      `${Base_URL}/gsone/getWorkOrderDetails?asset=${asset}&equipment=${equipment}`
    );
    return response.data;
  } catch (error) {
    Logger.messageStackTrace("Error fetching sq01catById:", error);
  }
};

export const getDCatTerminalDetails = async (asset) => {
  try {
    const response = await axiosGetCallWithToken(
      `${Base_URL}/gsone/getDCatTerminalDetails?asset=${asset}`
    );
    return response.data;
  } catch (error) {
    Logger.messageStackTrace("Error fetching sq01catById:", error);
  }
};

export const getStickerPdf = async (id, stickerData, type, isPrint) => {
  let response;
  try {
    const request_id = `${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
    const idParam = id === undefined ? `` : `&id=${id}`;
    const stickerDataParam =
      stickerData === undefined
        ? ``
        : `&stickerData=${JSON.stringify(stickerData)}`;
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/gsone/getStickerPdf?type=${type}&url=${currentUrl}${idParam}${stickerDataParam}&request_id=${request_id}&print=${isPrint}`,
      "application/pdf"
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const getWarehousePdf = async (id, stickerData, type, isPrint) => {
  let response;
  try {
    const request_id = `${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
    const idParam = id === undefined ? `` : `&id=${id}`;
    const stickerDataParam =
      stickerData === undefined
        ? ``
        : `&stickerData=${JSON.stringify(stickerData)}`;
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/gsone/getWarehousePdf?type=${type}&url=${currentUrl}${idParam}${stickerDataParam}&request_id=${request_id}&print=${isPrint}`,
      "application/pdf"
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};